var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1d314c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.9781 12.4149c0 2.39-1.9358 4.3274-4.32369 4.3274-2.38786 0-4.32384-1.9374-4.32384-4.3274 0-2.3899 1.93584-4.3275 4.32384-4.3275 2.38799 0 4.32369 1.9376 4.32369 4.3275z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.7213 12.4148c0 2.2497-.9679 4.0741-2.1619 4.0741s-2.1619-1.8244-2.1619-4.0741c0-2.2496.9677-4.07398 2.1617-4.07398s2.162 1.82378 2.162 4.07398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.6612 12.4148c0 2.0151-.3404 3.6497-.7604 3.6497s-.7602-1.6341-.7602-3.6497c0-2.0155.3404-3.64966.7602-3.64966.4199 0 .7604 1.63396.7604 3.64966z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.67bdbbafb0e7f9fe1ac8ebe5767d4d80.svg";
export { ForwardRef as ReactComponent };